<div class="row mb-4 mt-3">
  <div class="col-md-12 d-flex flex-row align-items-center">
    <h4 class="mb-0">
      <div (click)="voltar()" style="cursor: pointer;padding: 2px 20px 0 0;float: left;">
        <i class="fas fa-arrow-left"></i>
      </div>
      Visualização da eleição <strong>{{eleicaoParametrizacao.titulo}}</strong>
    </h4>
    <div class="badger"> {{eleicaoParametrizacao.statusEleicao.replace('_', ' ')}}
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <nav>
      <div class="nav nav-tabs nav-fill" role="tablist">
        <a class="nav-item nav-link active" data-toggle="tab" href="#nav-termo" role="tab" aria-controls="nav-contact" >Termos</a>
        <a class="nav-item nav-link" data-toggle="tab" href="#nav-cargos" role="tab" aria-controls="nav-contact" >Cargos</a>
        <a class="nav-item nav-link" data-toggle="tab" href="#nav-comprovantes" role="tab" aria-controls="nav-contact" >Comprovante</a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">

      <div class="tab-pane fade show active" id="nav-termo" role="tabpanel">
        <div class="row py-4">
          <div class="col-md-12">
              <div class="card p-3">
                <app-header [logoEleicao]="eleicaoParametrizacao.logo"></app-header>
                <app-termo-aceite class="p-3" [eleicaoParametrizacao]="eleicaoParametrizacao"></app-termo-aceite>
                <app-footer></app-footer>
              </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="nav-cargos" role="tabpanel">
        <div class="row py-4">
          <div class="col-md-12">
            <div class="card p-3">
              <div *ngIf="cargos && cargos.length > 1">
                <strong>Selecione um cargo para visualizar:</strong>
                <select name="idCargoSelecionado" class="form-control" (change)="selecionarCargo($event.target.value)">
                  <option *ngFor="let cargo of cargos" [value]="cargo.id">{{cargo.nome}}</option>
                </select>
                <hr>
              </div>
              <div *ngIf="cargoSelecionado; else semCargos">
                <app-header [logoEleicao]="eleicaoParametrizacao.logo"></app-header>
                <div class="px-4 py-2">
                  <app-canditado-listar [eleicaoParametrizacao]="eleicaoParametrizacao" [cargo]="cargoSelecionado"></app-canditado-listar>
                </div>
                <app-footer></app-footer>
              </div>
              <ng-template #semCargos>Nenhum cargo cadastrado para esta eleição ainda.</ng-template>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="nav-comprovantes" role="tabpanel">
        <div class="row py-4">
          <div class="col-md-12">
              <div class="card p-3">
                <app-header [logoEleicao]="eleicaoParametrizacao.logo"></app-header>
                <app-comprovante-voto class="p-3" [eleicao]="eleicaoParametrizacao" [isManager]="true"></app-comprovante-voto>
                <app-footer></app-footer>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
